import { render, staticRenderFns } from "./StatisticsCardVertical.vue?vue&type=template&id=12130966&scoped=true&"
import script from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardVertical.vue?vue&type=style&index=0&id=12130966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12130966",
  null
  
)

export default component.exports